import { Outlet } from 'react-router-dom';

import LoadingPage from '../components/LoadingPage';

const RequiredAuth = ({ isAuthenticatedToBackend }: { isAuthenticatedToBackend: boolean }) => {
  if (!isAuthenticatedToBackend) {
    return <LoadingPage message="Signing in to AMP" />;
  }

  return <Outlet />;
};

export default RequiredAuth;
